// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BNnHNqm3fMYo50 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  margin: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 10px var(--ds-space-100, 8px) 10px 38px;
  color: var(--ds-text-inverse, #ffffff);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-weight: var(--ds-font-weight-regular, 400);
}
@media print {
  .BNnHNqm3fMYo50 {
    display: none;
  }
}
.iWweVoefhiolPG {
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.sAyHJVYa2INPFs {
  border-radius: var(--ds-border-radius-100, 3px);
}
.cMBPuXjCbG4xg8 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 7px 15px;
}
.JZ0q5ehX4asmtI {
  z-index: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0);
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
.JZ0q5ehX4asmtI.Ofh2XZWAVjgmmQ {
  align-self: flex-start;
}
.qEGuw7adCODI5y {
  flex-grow: 1;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-right: 25px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
.qEGuw7adCODI5y a {
  color: var(--ds-link, #0c66e4);
}
.qEGuw7adCODI5y.sPjMUQX2pExZoD,
.qEGuw7adCODI5y.sPjMUQX2pExZoD a {
  color: var(--ds-text-inverse, #ffffff);
}
.sFBDWABrPneKWA {
  width: 32px;
  height: 32px;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-300, 24px);
  font-size: 24px;
  line-height: 32px;
  vertical-align: middle;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerContainer": `BNnHNqm3fMYo50`,
	"bannerShadow": `iWweVoefhiolPG`,
	"roundedCorners": `sAyHJVYa2INPFs`,
	"inlinePadding": `cMBPuXjCbG4xg8`,
	"actionButton": `JZ0q5ehX4asmtI`,
	"alignTop": `Ofh2XZWAVjgmmQ`,
	"textContent": `qEGuw7adCODI5y`,
	"lightText": `sPjMUQX2pExZoD`,
	"help": `sFBDWABrPneKWA`
};
export default ___CSS_LOADER_EXPORT___;
